// @flow
import * as React from 'react';
import { compose } from 'recompose';
import { withSvg } from './../../../components/Icon/withSvg';
import { GPath } from './../../../components/Icon/PathIcon';

const Icon = props => (
  <GPath fillRule="evenodd" {...props}>
    <path d="M2 16.828L15.907 4 30 17" />
    <path d="M6 13v14.971h7.323V23.33c0-2.04.895-3.06 2.686-3.06s2.695 1.02 2.712 3.06V28L26 27.971V13.256" />
  </GPath>
);

const SVG = compose(withSvg)(Icon);
export default (props: any) => (
  <SVG
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    stroke="black"
    centerAlign={false}
    {...props}
  />
);
